import {extendTheme} from '@chakra-ui/react';
import '@fontsource/inter/800.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/200.css';
import '@fontsource/inter/100.css';
import Input from './StyledConfig/Input';
import Button from './StyledConfig/Button';
import textTheme from './StyledConfig/Text';
import {FormLabel} from './StyledConfig/Form';
import Menu from './StyledConfig/Menu';
import {TextareaTheme} from './StyledConfig/Textarea';
import PinInputTheme from './StyledConfig/PinInput';
import {
    colorByMode,
    convertColorToCssVar,
    flattenColorPalette,
    generatePalette,
} from './themeHelper';
import {popoverTheme} from './StyledConfig/Popover';
import {switchTheme} from './StyledConfig/Switch';
import {checkboxTheme} from './StyledConfig/Checkbox';
import {tagTheme} from './StyledConfig/Tag';
import { FormLabelTheme } from "./StyledConfig/FormLabel";
import { FormErrorMessageTheme } from "./StyledConfig/FormErrorMessage";
import headingTheme from "./StyledConfig/Heading";

export const HEADER_HEIGHT = '80px';

export const cardWidthStyle = {base: '100%', md: '280px'};
export const cardHeightStyle = '128px';

export const designSystemColors = {
    light: {
        primary: 'primary.700',
        bg: 'bg.50',
        brighterBg: 'white',
        navBg: 'white',
        sideBarBg: 'white',
        depositCardBg: 'white',
        // sideBarText: 'gray.800',
        // text: 'gray.800',
        sideBarText: 'newGray.700',
        text: 'newGray.700',
        title: 'newGray.900',

        secondaryText: 'gray.700',
        active: 'primary.700',
        gray: 'gray.500',
        border: 'gray.200',
        gold: 'gold.500',
        copper: 'warning.300',
        silver: 'gray.200',

        success: 'success.500',
        warning: 'warning.400',
        pending: 'pending.400',
        error: 'error.500',
        tag: 'gray.300',

        menuHover: 'gray.100',
        menuActive: 'gray.200',

        filledBg: 'gray.100',
        filledBorder: 'gray.200',

        stockRed: 'error.600',
        stockGreen: 'success.500',

        Live: 'success.500',
        Rebate: 'warning.400',
        Hidden: 'error.500',
        tip: 'warning.200',

    },
    dark: {
        primary: 'primary.500',
        bg: 'bg.950',
        brighterBg: 'bg.900',
        navBg: 'bg.900',
        sideBarBg: 'bg.900',
        depositCardBg: 'bg.700',
        // sideBarText: 'gray.200',
        // text: 'gray.50',
        sideBarText: 'newGray.200',
        text: 'newGray.50',
        secondaryText: 'gray.200',
        active: 'primary.500',
        gray: 'gray.200',
        border: 'gray.500',
        gold: 'gold.500',
        copper: 'warning.300',
        silver: 'gray.200',

        success: 'success.500',
        warning: 'warning.400',
        pending: 'pending.400',
        error: 'error.500',
        tag: 'gray.400',

        menuHover: 'gray.600',
        menuActive: 'gray.500',

        filledBg: 'gray.800',
        filledBorder: 'gray.700',

        stockRed: 'error.600',
        stockGreen: 'success.500',

        Live: 'success.500',
        Rebate: 'warning.400',
        Hidden: 'error.500',
        tip: 'warning.200',

    },
};

//default theme for dev
const lightBg = "#fbfcfe";
const darkBg = '#131316';
const gray = {
    50: '#f6f6f7',
    100: '#e1e2e6',
    200: '#c3c5cc',
    300: '#9ea0aa',
    400: '#797b88',
    500: '#6e7985',
    600: '#4b4c56',
    700: '#3e3f47',
    800: '#34353b',
    900: '#2e2e33',
    950: '#131316',
};

const newGray = {
    50: '#f2f7fc',
    100: '#f8f9fc',
    200: '#f3f5f9',
    300: '#e2e5ec',
    400: '#ccd2da',
    500: '#9ea7b1',
    600: '#6e7985',
    700: '#41505f',
    800: '#313c47',
    900: '#212830',
    950: '#191c21'
};


const error = {
    50: '#fff1f1',
    100: '#ffe0e0',
    200: '#ffc7c7',
    300: '#ffa0a0',
    400: '#ff6a6a',
    450: '#EF6666',
    500: '#f94e4e',
    600: '#e61c1c',
    700: '#c21313',
    800: '#a01414',
    900: '#841818',
    950: '#480707',
};
const success = {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b',
};
// const primary = {
//     50: '#effaff',
//     100: '#def3ff',
//     200: '#b6eaff',
//     300: '#75dbff',
//     400: '#2cc9ff',
//     500: '#2646A3',
//     600: '#008fd4',
//     700: '#0072ab',
//     800: '#00608d',
//     900: '#065074',
//     950: '#04334d',
// };
const primary = {
    // 50: '#E6EBF9',
    // 100: '#CDD7F4',
    // 200: '#9BAFE8',
    // 300: '#6986DD',
    // 400: '#335BD1',
    // 500: '#2545A3',
    // 600: '#1D3681',
    // 700: '#172A64',
    // 800: '#0F1C43',
    // 900: '#080E21',
    // 950: '#040711',

    // 50: '#E1E4F8',
    // 100: '#B3C2ED',
    // 200: '#85A0E2',
    // 300: '#5880D7',
    // 400: '#335BD1',
    // 500: '#506fd9',
    // 600: '#4155A2',
    // 700: '#2D3E7C',
    // 800: '#1B2B4E',
    // 900: '#0C1C39',
    // 950: '#050A17'

    50: "#f6f7f9",
    100: "#ebeef3",
    200: "#d3d9e4",
    300: "#adbacc",
    400: "#8094b0",
    500: "#607797",
    600: "#4c5f7d",
    700: "#3e4d66",
    800: "#364256",
    900: "#313a49",
    950: "#242a36",
};




const pending = primary
// const pending = {
//     50: '#F2FBFD',
//     100: '#E1F5F9',
//     200: '#BEEAF3',
//     300: '#93DCEB',
//     400: '#64CDE2',
//     500: '#2CBBD8',
//     600: '#229FB8',
//     700: '#1D8A9F',
//     800: '#197385',
//     900: '#12525F',
//     950: '#0E3F49',
// };


const warning = {
    50: '#fff9eb',
    100: '#ffeec6',
    200: '#ffdb88',
    300: '#ffc24a',
    400: '#ffad29',
    500: '#f98607',
    600: '#dd6002',
    700: '#b74106',
    800: '#94310c',
    900: '#7a290d',
    950: '#461302',
};

const lightGray = {
    '50': '#f5f5f5',
    '100': '#f5f5f5',
    '200': '#e6e6e6',
    '300': '#cccccc',
    '400': '#adadad',
    '500': '#969696',
    '600': '#858585',
    '700': '#757575',
    '800': '#6e6e6e',
    '900': '#737373',
    '950': '#808080',
}

const gold = {
    '50': '#fffee7',
    '100': '#fffec1',
    '200': '#fff886',
    '300': '#ffec41',
    '400': '#ffdb0d',
    '500': '#ffcc00',
    '600': '#d19500',
    '700': '#a66a02',
    '800': '#89530a',
    '900': '#74430f',
    '950': '#442304',
};

// const bgPalette = generatePalette(lightBg, darkBg);
const bgPalette = {
    50: "#f6f7f9",
    100: "#ebeef3",
    200: "#d3d9e4",
    300: "#adbacc",
    400: "#8094b0",
    500: "#607797",
    600: "#4c5f7d",
    700: "#3e4d66",
    800: "#364256",
    900: "#313a49",
    950: "#242a36",
};

export const designSystemPalette = {
    gray,
    light: {
        bg: bgPalette,
        primary,
        gray,
        error,
        success,
        warning,
        pending,
        lightGray,
        gold,
        newGray
    },
    dark: {
        bg: bgPalette,
        primary,
        gray,
        error,
        success,
        warning,
        pending,
        lightGray,
        gold,
        newGray
    },
};

export const defaultTheme = {
    components: {
        Input,
        Button,
        FormLabel,
        Menu,
        Textarea: TextareaTheme,
        PinInput: PinInputTheme,
        Popover: popoverTheme,
        Switch: switchTheme,
        Checkbox: checkboxTheme,
        Tag: tagTheme,
        Text: textTheme,
        FormLabel: FormLabelTheme,
        FormError: FormErrorMessageTheme,
        Heading: headingTheme,
    },
    shadows: {
        outline: `0 0 0 2px ${convertColorToCssVar("light.primary.600")}`,
        sideBar: "15px 1px 34px 0px rgba(0,0,0,0.05);",
        lg: "0 5px 20px 3px rgba(44, 72, 158, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    },
    colors: designSystemPalette,
    config: {
        initialColorMode: "light",
        useSystemColorMode: false,
        disableTransitionOnChange: false,
    },
    fonts: {
        heading: `'Inter', sans-serif`,
        body: `'Inter', sans-serif`,
        mono: `'Inter', sans-serif`,
    },
    styles: {
        global: (props) => {
            return {
                body: {
                    color: colorByMode("text", props.colorMode),
                    bg: colorByMode("bg", props.colorMode),
                },
                // 'img, video': {
                //     height: 'revert-layer',
                //     maxWidth: 'revert-layer',
                // },
            };
        },
    },
}
export default extendTheme(defaultTheme);


export const getCustomTheme = (palettes) =>
    extendTheme({
        ...defaultTheme,
        colors: {
            ...defaultTheme.colors,
            light: {
                ...defaultTheme.colors.light,
                ...palettes,
            },
            dark: {
                ...defaultTheme.colors.dark,
                ...palettes,
            },
        },
        config: {
            ...defaultTheme.config,
        },
    });
